import { Injectable } from '@angular/core';
import { environment } from '../config/environment';
import { HttpClient ,HttpErrorResponse} from '@angular/common/http';
import { catchError ,retry} from 'rxjs/operators';
import { throwError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  baseUrl = environment.baseUrl;
  constructor(private httpRequest: HttpClient) { 
    


  }

//   geturl() {
//     let url = this.baseUrl ;
//     console.log(JSON.stringify(url))
//     return this.httpRequest.get<JSON>(url);
//   }

  createEmployee = (employeeDetails) => {
    return this.httpRequest.post(this.baseUrl + 'employees', employeeDetails);
  }
  updateEmployee = (employeeDetails, employeeId) => {
    return this.httpRequest.patch(this.baseUrl + 'employees/' + employeeId, employeeDetails);
  }
  getEmployees = () => {
    return this.httpRequest.get(this.baseUrl + 'employees');
  }
  getSingleEmployee = (employeeId) => {
    return this.httpRequest.get(this.baseUrl + 'employees/' + employeeId);
  }
  updateEmployeeProfile = (employeeDetails, employeeId) => {
    return this.httpRequest.patch(this.baseUrl + 'employees/' + employeeId, employeeDetails);
  }
  handleError(error: HttpErrorResponse){
    console.log(JSON.stringify(error.error))
    
      return throwError(error);
      }
}